export const setFirstLetterUpercase = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const arrayToOption = (
  array = [],
  value = "id",
  label = "name",
  appendLabelName = null
) => {
  let options = [];
  array.forEach((item) => {
    let labelText = appendLabelName
      ? `${item[appendLabelName]} ${item[label]}`
      : item[label];
    options = [...options, { value: item[value], label: labelText }];
  });
  return options;
};

export const optionsToArray = (options, value = "id", label = "name") => {
  let array = [];

  options.forEach((item) => {
    array = [...array, { [value]: item.value, [label]: item.label }];
  });

  return array;
};

export const arrayToQuery = (array, value = "value") => {
  let query = "";

  array.forEach((item, key) => {
    query += `${item[value]}`;
    if (key < array.length - 1) query += ",";
  });

  return query;
};

export const currencyFormatter = (value) => {
  if (isNaN(value)) {
    return "-";
  }
  return new Intl.NumberFormat("es-AR", {
    style: "currency",
    currency: "ARS",
  }).format(value);
};

export const numberFormatter = (value) => {
  if (isNaN(value)) {
    return "-";
  }
  return new Intl.NumberFormat("es-AR", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};
